import { useEffect, useState } from "react";
import SequenceService from "@/services/sequenceService";

/**
 * The one served `{{variable}}` list (OUTREACH_OVERHAUL.md §7), the list
 * Confirm validates against. Empty until it loads, and empty if it fails —
 * a picker then offers nothing, and Confirm's server check still applies.
 *
 * `systemKey` — a product-seeded template's `system_key` — picks that
 * template's own set from `by_system_key` (the compliance email needs
 * `{{document_list}}` and `{{compliance_portal_link}}`). Any other value gets
 * the general set.
 */
const useOutreachVariables = (systemKey) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    let cancelled = false;
    SequenceService.variables()
      .then((res) => {
        if (!cancelled) setData(res || null);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return (systemKey && data?.by_system_key?.[systemKey]) || data?.variables || [];
};

export default useOutreachVariables;
